<template>
  <div>
    <div class="alert alert-warning" v-if="remaining">
      <h4 class="alert-heading"><i class="fa fa-warning"></i>
        <countdown :time="remaining * 1000" @ended="alert('Ended')">
          <template slot-scope="props">
            Verbleibende Zeit：{{ props.minutes }} Minuten, {{ props.seconds }} Sekunden.
          </template>
        </countdown>
      </h4>
      Sie haben 10 Minuten um Ihre Bestellung abzuschließen, bei Bedarf können Sie die Zeit verlängern.
      <hr>
      <span class="mb-0"><a href="#" @click.prevent="increaseReservation()" class="alert-link">Hier klicken</a> um mehr
        Zeit zu erhalten.</span>
    </div>

    <div class="alert alert-info" role="alert">
      <h4 class="alert-heading">
        <i class="fas fa-info-circle"></i> {{ translate('payment.note') }}
      </h4>

      <span v-if="remaining">
        Nach der Zahlung müssen die persönlichen Daten vollständig ausgefüllt werden. Bei der Prüfung müssen <b>ein
        gültiger Lichtbildausweis</b> (Liste gültiger Dokumente[LINK EINFÜGEN]) vorgelegt werden, sonst ist die
        Teilnahme an der Prüfung nicht möglich! (keine Rückerstattung des Kaufpreises)
      </span>
      <span v-else>{{ translate('payment.note_text') }}</span>
    </div>


    <div class="container mt-5">
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <div class="date-block-img-wrapper">
            <div class="img-wrapper-av">
              <img :src="subtestAttempt ? subtestAttempt.subtest.image_path : '/images/icon-IP.svg'"
                   alt="credit-card">
            </div>
            <div v-if="subtestAttempt ? subtestAttempt.speaking_appointment_at : false" class="info-block">
              <div class="text-center">
                <p class="year font-weight-bold mb-0 text-left">
                  {{ translatedFormat(subtestAttempt.speaking_appointment_at, 'D ddd') }}</p>
                <p class="font-weight-bolder mb-0 text-left">
                  {{ translatedFormat(subtestAttempt.speaking_appointment_at, 'MMM') }}</p>
                <p class="font-weight-light mb-0 text-left">
                  {{ translatedFormat(subtestAttempt.speaking_appointment_at, 'YYYY ') }}</p>
              </div>
              <div>
                <div class="font-weight-bolder mb-0">
                  {{ translatedFormat(subtestAttempt.speaking_appointment_at, 'H a') + ' - ' + translatedFormat(subtestAttempt.speaking_appointment_at, 'H a', true) }}
                </div>
              </div>
            </div>

            <div v-else-if="testAttempt ? testAttempt.test.TER_DATUM : false">
              <div class="date-block-av">
                <div class="number-av">{{ translatedFormat(testAttempt.test.TER_DATUM, 'D ddd') }}</div>
                <div class="month-av">{{ translatedFormat(testAttempt.test.TER_DATUM, 'MMM') }}</div>
                <div class="year-av">{{ translatedFormat(testAttempt.test.TER_DATUM, 'YYYY') }}</div>
              </div>
              <div class="start-block-av">
                <div class="begin-av">{{ translate('landing.info_block.starts') }}</div>
                <div class="hour-av">{{ testAttempt.test.TER_UHRZEIT }}</div>
                <div v-if="lang === 'de'" class="time-av">Uhr</div>
              </div>
            </div>

            <div v-if="subtestAttempt">
              <div v-if="subtestAttempt.invoice && subtestAttempt.payment">
                <div class="info-block">
                  <div>
                    <p class="info-block-md">{{ translate('landing.info_block.order') }}:
                      {{ subtestAttempt.invoice.ppr_nr }}</p>
                    <p class="info-block-sm">
                      <b>{{ translatedFormat(subtestAttempt.payment.created_at, 'D MMM') }}</b>
                      {{ translatedFormat(subtestAttempt.payment.created_at, 'YYYY') }}
                    </p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="">
                  <icons :subtest="subtestAttempt.subtest"></icons>
                </div>
                <div class="">
                  <h6 v-if="subtestAttempt.subtest.subtest_type_id === 3">
                    {{ translate('landing.info_block.only_writing') }}</h6>
                  <h6 v-else-if="subtestAttempt.subtest.subtest_type_id === 4">
                    {{ translate('landing.info_block.only_speaking') }}</h6>
                  <h6 v-else>{{ translate('landing.info_block.all_modules') }}</h6>
                </div>
                <div class="info-block-price mt-2"><i class="fas fa-euro-sign"></i> {{ decimalNumber(amount) }}</div>
              </div>
            </div>
            <div v-else-if="testAttempt">
              <div class="info-block">
                <div>
                  <div class="begin-av">{{ translate('landing.info_block.test_price') }}</div>
                  <div class="hour-av">
                    <i class="fas fa-euro-sign"></i> {{ decimalNumber(amount) }}
                  </div>
                  <div class="time-av">{{ translate('landing.info_block.per_participant') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-3">
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <div class="d-flex justify-content-between align-self-center black-border-bottom color-black text-600">
            <div>
              <span v-if="couponApplied && !couponData.error">{{ translate('payment.regular') + ' ' }}</span>
              {{ translate('payment.price') }}
            </div>
            <div>
              <span v-if="couponApplied && !couponData.error"><del>{{ decimalNumber(amount) }}</del></span>
              <span v-else>{{ decimalNumber(amount) }}</span> <i class="fas fa-euro-sign" /></div>
          </div>

          <div v-if="couponApplied && !couponData.error"
               class="d-flex justify-content-between align-self-center black-border-bottom color-black text-600 mt-4">
            <div>{{ translate('payment.you_save') }}</div>
            <div>{{ (Math.round((amount - newAmount.amount) * 100) / 100).toFixed(2) }} <i class="fas fa-euro-sign" />
            </div>
          </div>

          <div v-if="couponApplied && !couponData.error"
               class="new-price d-flex justify-content-between align-self-center black-border-bottom color-black text-600 mt-4">
            <div>{{ translate('payment.new_price') }}</div>
            <div>{{ newAmount ? newAmount.amount : null }} <i class="fas fa-euro-sign" /></div>
          </div>

          <div
            class="d-flex justify-content-between align-items-center mt-4 pb-2 black-border-bottom color-black text-600">
            <div>{{ translate('payment.coupon_code') }}</div>
            <div class="w-50">
              <input v-model="couponData.coupon"
                     :class="{'is-invalid': couponData.error}"
                     type="text" placeholder="Ihr Gutscheincode..."
                     class="form-control w-100 text-center">
            </div>
            <button @click="applyCoupon"
                    class="btn btn-primary card-shadow">
              Einlösen
            </button>
          </div>

          <div v-if="couponApplied && !couponData.error"
               class="success-message d-flex justify-content-between align-self-center text-600 mt-4">
            <p class="success-message">
              {{ translate('payment.success_message') }}
            </p>
          </div>

          <div class="text-sm text-danger text-center font-weight-bold" role="alert"
               v-if="couponData.error">
            <strong>{{ couponData.error }}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-5">
      <div class="row justify-content-md-center">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="terms" v-model="terms">
          <label class="custom-control-label" for="terms">
            {{ translate('payment.i_have_read') }} <a href="https://www.osd.at/agb/" target="_blank">
            {{ translate('payment.general_terms') }}</a> {{ translate('payment.i_agree') }}
          </label>
        </div>
      </div>
    </div>

    <section class="style-block-av p-3 mt-5">
      <div class="row justify-content-md-center">
        <div class="col-sm-6">
          <div class="payment_option_ors success">
            <p>{{ translate('payment.credit_card') }}</p>
            <img src="/images/credit-card-logos.png" alt="credit-card">
          </div>
        </div>
      </div>

      <div class="payment-methods">
        <div class="row justify-content-md-center">
          <div class="col-sm-6">
            <stripe :stripe-public-key="publicKey" :amount="amount" :new-amount="newAmount" :coupon="couponData.coupon"
                    :payment-option="paymentOption"
                    :terms="terms"></stripe>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import Swal from 'sweetalert2';
import VueCountdown from '@chenfengyuan/vue-countdown';
import moment from 'moment/moment';
import axios from 'axios';
import tz from 'moment-timezone';

export default {
  mixins: [require('../../../../resources/js/mixin')],

  props: [
    'publicKey',
    'remaining',
    'testAttempt',
    'amount',
    'lang',
    'subtestAttempt',
  ],

  components: {
    Swal,
    countdown: VueCountdown
  },

  data () {
    return {
      updateTestAttemptForm: new AppForm({}),
      terms: false,
      paymentOption: null,
      showPayButton: false,
      couponData: {
        error: null,
        coupon: null,
      },
      newAmount: null,
      couponApplied: false,
    };
  },

  methods: {
    decimalNumber (number) {
      return Number.isInteger(number) ? number.toFixed(2) : number;
    },

    applyCoupon () {
      axios.post('/api/apply-coupon/', { 'coupon': this.couponData.coupon })
        .then(response => {
          this.newAmount = {
            'amount': (Math.round(response.data.price * 100) / 100).toFixed(2),
            'coupon': this.couponData.coupon
          };
          this.couponApplied = true;
          this.couponData.error = null;
        }).catch(err => {
        this.newAmount = null;
        this.couponData.error = err.response.data.errors.coupon[0];
      });
    },

    increaseReservation () {
      App.put('/api/test-attempts/' + this.testAttempt.id + '/reservation', this.updateTestAttemptForm)
        .then(() => {
          window.location.href = '/payments/create';
        });
    },

    translatedFormat (value, format, addOur = false) {
      moment.locale(this.lang);
      if (addOur) {
        value = moment(value).add(1, 'hour');
      }

      return moment.tz(value, window.App.timezone).format(format);
    }

  },
};
</script>

<style>
.payment_option_ors.success {
    border-color: #38c172 !important;
}

.black-border-bottom {
    border-bottom: 1px solid #666666
}

.color-black {
    color: black;
}

.text-600 {
    font-weight: 600;
}

.new-price {
    color: #0872BA;
    font-size: 18px;
    font-weight: 600;
}

.success-message {
    color: #38C172;
    font-size: 16px;
}
</style>
